import { render } from "./ModalNewAttribute.vue?vue&type=template&id=08b50cd7"
import script from "./ModalNewAttribute.vue?vue&type=script&lang=js"
export * from "./ModalNewAttribute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__